"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languages = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
var _Translations = require("../Translations");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var languages = [{
  id: 'fr',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Fran\xE7ais",
    defaultMessage: "Fran\xE7ais"
  }),
  flag: 'fr'
}, {
  id: 'en',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Anglais",
    defaultMessage: "Anglais"
  }),
  flag: 'us'
}, {
  id: 'de',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Allemand",
    defaultMessage: "Allemand"
  }),
  flag: 'de'
}, {
  id: 'gr',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Grec",
    defaultMessage: "Grec"
  }),
  flag: 'gr'
}, {
  id: 'jp',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Japonais",
    defaultMessage: "Japonais"
  }),
  flag: 'jp'
}, {
  id: 'pt',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Portugais",
    defaultMessage: "Portugais"
  }),
  flag: 'pt'
}, {
  id: 'ru',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Russe",
    defaultMessage: "Russe"
  }),
  flag: 'ru'
}, {
  id: 'es',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Espagnol",
    defaultMessage: "Espagnol"
  }),
  flag: 'es'
}, {
  id: 'sv',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Su\xE9dois",
    defaultMessage: "Su\xE9dois"
  }),
  flag: 'se'
}, {
  id: 'tr',
  name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Turc",
    defaultMessage: "Turc"
  }),
  flag: 'tr'
}];
exports.languages = languages;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    languageButton: {
      height: 40,
      width: 40,
      '& img': {
        marginLeft: 4,
        marginRight: 4,
        minWidth: 20
      },
      '& p': {
        marginLeft: 4,
        marginRight: 4,
        fontWeight: 'bold'
      }
    },
    languagesMenu: {
      paddingTop: 8,
      paddingBottom: 8
    },
    languageItemIcon: {
      minWidth: 40,
      '& img': {
        minWidth: 20
      }
    },
    languageText: {
      color: theme.palette.primary.contrastText
    }
  };
});
function LanguageSwitcher(props) {
  var currentLanguage = props.currentLanguage,
    enabledLanguages = props.enabledLanguages;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    menu = _useState2[0],
    setMenu = _useState2[1];
  var classes = useStyles(props);
  var dispatch = (0, _reactRedux.useDispatch)();
  var language = languages.find(function (lng) {
    return lng.id === currentLanguage;
  }) || languages[0];
  var langMenuClick = function langMenuClick(event) {
    setMenu(event.currentTarget);
  };
  var langMenuClose = function langMenuClose() {
    setMenu(null);
  };
  function handleLanguageChange(locale) {
    //add reload to our dispatch
    dispatch({
      type: 'SWITCH_LOCALE_WITH_COOKIES',
      locale: locale,
      reload: true
    });
    langMenuClose();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.languageButton,
    onClick: langMenuClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "https://s2.svgbox.net/flags-hd.svg?ic=".concat(language.flag),
    alt: language.name
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    className: classes.languageText
  }, language.id)), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    open: Boolean(menu),
    anchorEl: menu,
    onClose: langMenuClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    classes: {
      paper: classes.languagesMenu
    }
  }, enabledLanguages.map(function (element) {
    var lng = languages.find(function (item) {
      return item.id === element;
    }) || languages[0];
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: lng.id,
      onClick: function onClick() {
        return handleLanguageChange(lng.id);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
      className: classes.languageItemIcon
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "https://s2.svgbox.net/flags-hd.svg?ic=".concat(lng.flag),
      alt: lng.name,
      width: 32,
      height: 32
    })), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
      primary: lng.name
    }));
  })));
}
LanguageSwitcher.defaultProps = {
  currentLanguage: 'fr',
  enabledLanguages: ['fr']
};
var _default = LanguageSwitcher;
exports.default = _default;